
    <div class="row">
        <div class="col-md-12 text-right noprint" style="margin-bottom: 15px;" >
            
                        <button class="globalBtn clearBtn" (click)='printComponent()'>Print <i
                            class="fa fa-print "></i></button>
            <button type="button" class="globalBtn btn-success" style="margin-right: 25px;"  (click)="Back()">Back</button>
        </div> 
       
    
       
                
            </div>
            <!-- <div>
                <div class="row" style="padding-top: 10px;">
                    <div class="col-md-12">
                        <legend class="headingValue">View Anti-Ragging Report</legend>
                    </div>
                </div>
                </div> -->
    <div class="container h-100 container-body" >
    <div id="proformaView">
        <div class="col-md-11">                   
            <div class="panel panel-primary panel-proforma" style="margin-left: 88px;">
                <div class="panel-heading" style="font-size: 20px;text-align: center;font-weight: bold;">Proforma View</div>
            </div>
            <div class="row">
                <div class="col-md-6" style="font-size: 20px;">
                    <h5 class="headingValue"></h5>
                </div>
            </div>
                </div>

    <div class="row">
        <div class="card">
            
<form [formGroup]="form" novalidate>
    <div>
        <div class="col-md-12" *ngFor="let item of proformaDetails.sections;let i=index">
            <div class="row" style="font-size: 22px;">
                <div class="col-md-12">
                <h4 class="headingValue">{{item.section}}.  {{item.name}} </h4>
                <hr>
            
            </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <table class="table table-bordered table-hover">
                            <thead class="thead-light">
                                <tr> 
                                  <th style="white-space: nowrap;text-align: left;">Name</th>
                                  <th style="white-space: nowrap;text-align: left;">Required</th>
                                  <th style="white-space: nowrap;text-align: left;">Inspector -1</th>
                                  <th style="white-space: nowrap;text-align: left;">Inspector -2</th>
                               </tr>
                            </thead>  
                            <tbody>
                                <tr *ngFor="let flds of item.flds;let j=index">
                                   
                                    <td style="font-weight: bold;">{{flds.name}}</td>
                                    <td>{{flds.required !== null ?(flds.required) : '-'}}</td>
                                    <td *ngIf="flds.readOnly==false">{{flds.actualValue !== null ?(flds.actualValue) : '-'}}</td>
                                    <td *ngIf="flds.readOnly==false">{{flds.actualValue2 !== null ?(flds.actualValue2) : '-'}}</td>
                                    <td *ngIf="flds.readOnly==true">{{flds.readOnlyValue !== null ?(flds.readOnlyValue) : '-'}}</td>
                                    <td *ngIf="flds.readOnly==true">{{flds.readOnlyValue2 !== null ?(flds.readOnlyValue2) : '-'}}</td>

                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>
                
            </div>


            <!-- <div class="col-md-2"></div>
            <div class="col-md-10">
            <div class="row" *ngFor="let flds of item.flds;let j=index">
            <div class="row" style="padding-left: 20px;">
                <div class="col-md-12">
                    <p class="subHeadingValue">{{flds.name}}</p>
                </div> -->
                <!-- <div class="col-md-4">
                    <p class="subHeading">{{flds.actualValue}}</p>
                </div> -->
                <!-- <div class="col-md-4" *ngIf="flds.readOnly==false">
                    <p class="subHeading">{{flds.actualValue}}</p>
                </div>
                <div class="col-md-4" >
                    <p class="subHeading">{{flds.readOnlyValue}}</p>
                </div>
            </div>
        </div>
            </div> -->


</div>
</div>

</form>
</div>
</div>

</div>
<div class="row d-flex my-2 justify-content-center">
    <button class="btn btn-secondary mx-2" (click)="Back()">Back</button>
</div>